import { Stack, Typography, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const DemoTopBarBanner = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{
        backgroundColor: '#d32f2f',
        color: 'white',
        py: 1,
        px: 2,
        borderBottom: '2px solid #b71c1c',
      }}
    >
      <Typography fontSize="12px" fontWeight="500" variant="body2">
        <FormattedMessage id="demo.bannerMessage" />
      </Typography>
      <Button
        variant="contained"
        size="small"
        sx={{
          backgroundColor: 'white',
          color: '#d32f2f',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        }}
        // href="http://localhost:3004/hairdresser/subscription?plan=expert"
        href={`https://${
          import.meta.env.VITE_SUBDOMAIN
        }.kadernikplus.cz/hairdresser/subscription?plan=expert`}
      >
        <FormattedMessage id="demo.buy" />
      </Button>
    </Stack>
  );
};

export default DemoTopBarBanner;
